import styles from '../IMSLDAPValidator.module.scss';
import Base from 'pages/Base/Base';
import TransformedDataTable from './TransformedDataTable';
import { nanoid } from 'nanoid';

const InfonetResults = infonetResults => {
	const headers = [
		{ Value: 'Name (CN)', props: { sort: null, onSortChange: null } },
		{
			Value: 'Groups (memberOf)',
			props: { sort: null, onSortChange: null },
		},
	];

	const extractGroups = groups => {
		if (groups) {
			const groupArray = groups.map(group => {
				const match = group.match(/CN=([^,]+)/);
				return match[1] ? match[1] : null;
			});
			return groupArray.join('\n');
		} else return groups;
	};

	const rows = Object.entries(infonetResults).map(([key, data]) => {
		return {
			Cells: {
				'Name (CN)': {
					Value: data.ErrorMessage ? data.ErrorMessage : data.CN,
					Validation: {
						Key: 'true',
						Value: null,
						memberToValidateKey: null,
					},
				},
				'Groups (memberOf)': {
					Value: extractGroups(data.groups),
					Validation: {
						Key: 'true',
						Value: null,
						memberToValidateKey: null,
					},
				},
			},
			Key: nanoid(),
		};
	});

	return (
		<Base title='Infonet OU' className={styles.inContainer}>
			<TransformedDataTable
				rows={rows}
				headers={headers}
				className={styles.Table_Overrides2}
			/>
		</Base>
	);
};

export default InfonetResults;
